export const DealStatus = Object.freeze({
  EXPIRED: 'EXPIRED',
  OPEN: 'OPEN',
  ACTIVATED: 'ACTIVATED'
})

export const BillingCollectionMethod = Object.freeze({
  MANUAL: 'MANUAL',
  AUTOMATIC: 'AUTOMATIC'
})

export const CustomerSegment = Object.freeze({
  VSB: 'VSB',
  SMB: 'SMB',
  SME: 'SME',
  ENT: 'ENT'
})

export const NewOrgAssignedProperties = Object.freeze({
  signUpDone: true
})

export const NewOrgAssignedConfiguration = Object.freeze({
  chatEnabled: false
})

export const ICPSegments = Object.freeze([
  CustomerSegment.SME,
  CustomerSegment.ENT
])

export const DefaultPlanName = 'your new plan'

export const DealCodeCookie = 'DEAL_CODE'


// WEBPACK FOOTER //
// ./src/constants/dealConstants.js